import MyTableGuestsCompanion from './MyTableGuestsCompanion';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { infoInvitation } from 'services/rsvp/getRSVP';
import { useWindowSize } from 'hooks';
function MyGuestsCompanion({
  tableInfo,
}) {

  const history = useHistory();
  const [typeId, setTypeId] = useState(tableInfo?.evento);
  const [showButton, setShowButton] = useState(false);
  const [, { isMobile }] = useWindowSize();
  const handleRedirectAgregaInvitados = () => {
    //  alert('Agregando invitados por separado');
    history.push('/agrega-invitados');
  };

  const handleRedirectContinuar = () => {
    //alert('continuar.....');
    history.push('/agrega-invitados-excel/'+tableInfo?.evento+'/4');
  };

  const handleRegresarClick = () => {
    history.push('/rsvp');
  };

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, []);

  useEffect(() => {
    setTypeId(tableInfo?.evento);
  }, [tableInfo]);

  useEffect(() => {
    infoInvitation(typeId).then((valorDeServicio) => {
      console.log('infoInvitation en Companion', valorDeServicio);
      if(valorDeServicio?.metadata?.http_status === 404){
        setShowButton(true);
      }else{
        setShowButton(false);
      }
    });
  }, [typeId]);

  return (
    <>
    {!isMobile && (<span className="float-left" onClick={handleRegresarClick}><i class="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span>) }
      <div className='container text-center p-4'>
        <h1>Confirma a tus invitados</h1>
        <MyTableGuestsCompanion typeId={tableInfo?.evento} />
        <div className='d-flex justify-content-center mt-4'>
          <div className='col-md-4' style={{ flex: '1' }}>
            <Button
              id={22}
              block
              variant="secondary"
              onClick={handleRedirectAgregaInvitados}
              type="button"
              className={''}>
              Agregar invitado
            </Button>
          </div>
          { showButton && (
          <div className='col-md-4' style={{ flex: '1' }}>
            <Button
              id={22}
              block
              variant="primary"
              onClick={handleRedirectContinuar}
              type="button"
              className={''}>
              Continuar
            </Button>
          </div>
          )}
        </div>
      </div>

    </>
  );
}

export default MyGuestsCompanion;
